import { ScanLine, Users, Target, BellRing } from "lucide-react";

const ITEMS = [
  { icon: ScanLine, label: "Scan & Save" },
  { icon: Users, label: "Smart Contact Organization" },
  { icon: Target, label: "Networking Goals" },
  { icon: BellRing, label: "Follow-Up Reminders" },
];

export const TrustStrip = () => (
  <section className="border-y border-slate-100 bg-slate-50/70 py-8" data-testid="trust-strip">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 sm:px-6 lg:grid-cols-4 lg:px-8">
      {ITEMS.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-3" data-testid={`trust-item-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-toto-lavender text-toto-blue">
            <Icon className="h-5 w-5" />
          </span>
          <span className="text-sm font-semibold text-slate-800 sm:text-base">{label}</span>
        </div>
      ))}
    </div>
  </section>
);
